import { RequestPart } from '@/app/system/request/RequestPart';
import { Guest } from '@/app/system/guest/Guest';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { Value } from '@/app/system/guest/Value';
import { RequestDocument } from '@/app/system/request/RequestDocument';
import { GuestChain } from '@/app/system/guest/GuestChain';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';

export class Filter implements RequestPart, Guest<Record<string, any>>, GuestAware<Record<string, any>> {
  private filterCache = new Value({}, this);

  public constructor(private baseRequest: RequestPart) {
  }

  public filter<R extends Guest<Record<string, any>>>(guest: R): R {
    this.filterCache.receiving(guest);
    return guest;
  }

  public request(guest: Guest<RequestDocument>) {
    const chain = new GuestChain<{ filter: Record<string, any>, request: any }>();
    this.filterCache.receiving(chain.receiveKey('filter'));
    this.baseRequest.request(chain.receiveKey('request'));

    chain.result(new GuestDynamic(({
      filter,
      request,
    }) => {
      Object.entries(filter).forEach(([key, value]) => {
        if (value === '') {
          request.params[key] = undefined;
        } else {
          request.params[key] = value;
        }
      });
      guest.receive(request);
    }));

    return this;
  }

  public receiving(guest: Guest<Record<string, any>>): this {
    this.filter(guest);
    return this;
  }

  public introduction() {
    return 'guest' as const;
  }

  public receive(value: Record<string, any>): this {
    this.filterCache.receive(value, {
      specificData: {
        oldValue: null,
      },
    });
    return this;
  }
}
